import { render, staticRenderFns } from "./FooterLpMinimal.vue?vue&type=template&id=f40d798c&"
import script from "./FooterLpMinimal.vue?vue&type=script&lang=js&"
export * from "./FooterLpMinimal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports